<div class="wrap-break-word border-t border-b border-gray-200 md:border-0 px-4 py-2 grid grid-cols-[40%_45%_15%] gap-1
 items-baseline">
  <span class="text-sm pt-1">Heute: </span>
  <span class="text-lg celsius pt-1"> {{weatherModel().today_min}}/{{weatherModel().today_max}} <span class="text-xs">°C</span></span>
  <span class="align-baseline">
    <img src="/assets/app_icon_{{weatherModel().weather_icon}}.svg" class="weather-icon h-8 inline-block" alt="weather-icon">
  </span>
  <span class="text-sm">Erw. PV-Ertrag:</span>
  <app-pv-yield day="today" [valueOnly]="true"></app-pv-yield>
</div>
